import { render, staticRenderFns } from "./LogoWatermarkToColor.vue?vue&type=template&id=7f6fa94e&scoped=true"
var script = {}
import style0 from "./LogoWatermarkToColor.vue?vue&type=style&index=0&id=7f6fa94e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6fa94e",
  null
  
)

export default component.exports